<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t("informeDeVentasDeProductosDePedidos")}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("companya")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idCompany"
                                           filterable
                                           @change="getBusiness()"
                                           :placeholder="$t('seleccionaCompania')">
                                    <el-option v-for="c in listCompany"
                                               class="select-primary"
                                               :value="c.id"
                                               :label="c.name"
                                               :key="c.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-1" style="margin-top: 10px">
                            <label> </label><br>
                            <div class="form-group">
                                <el-checkbox v-model="mostrarRecoger">
                                    <strong>{{$t("recogerEnPedidos")}}</strong>
                                </el-checkbox>
                            </div>
                        </div>

                        <div class="col-md-1" style="margin-top: 10px">
                            <label> </label><br>
                            <div class="form-group">
                                <el-checkbox v-model="mostrarDomicilio">
                                    <strong>{{$t("domicilioEnPedidos")}}</strong>
                                </el-checkbox>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>&nbsp;</label>
                                <button class="btn btn-primary" @click="getSalesProducts()" style="width: 100%">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <template v-if="list.length>0">

                    <div class="row col-md-12">
                        <div class="col-md-4">
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{$t("exportarInforme")}} <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i> {{$t("exportarPdf")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i> {{$t("exportarExcel")}}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>

                        </div>

                        <div class="col-md-8 text-right justify-content-end">
                            <div class="row col-md-12 text-right justify-content-end">
                                <p style="text-align: right;"><strong>{{$t("ticketMedioRecoger")}}</strong> {{parseFloat(ticketMedioRecoger).toFixed(2) | currency}}</p>
                                <span style="margin: 0 1rem">|</span>
                                <p style="text-align: right;"><strong>{{$t("ticketMedioDomicilio")}}</strong> {{parseFloat(ticketMedioDomicilio).toFixed(2) | currency}}</p>
                            </div>
                            <div class="row col-md-12 text-right justify-content-end">
                                <p style="text-align: right;"><strong>{{$t('numeroPedidosRecoger')}}:</strong> {{list[0].numRecoger}}</p>
                                <span style="margin: 0 1rem">|</span>
                                <p style="text-align: right;"><strong>{{$t('numeroPedidosDomicilio')}}:</strong> {{list[0].numDomicilio}}</p>
                            </div>
                        </div>
                    </div>

                    <template>
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped text-nowrap">
                                <thead class="thead-dark">
                                <tr>
                                    <th v-if="ordenarProducto===0" @click="sortedArrayProductoASC('producto')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("producto")}}
                                    </th>
                                    <th v-else @click="sortedArrayProductoDESC('producto')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("producto")}}
                                    </th>
                                    <th v-if="ordenarCantidad===0" @click="sortedArrayCantidadASC('cantidad')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("cantidad")}}
                                    </th>
                                    <th v-else @click="sortedArrayCantidadDESC('cantidad')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("cantidad")}}
                                    </th>
                                    <th v-if="ordenarPrecio===0" @click="sortedArrayPrecioASC('precio')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("precio")}}
                                    </th>
                                    <th v-else @click="sortedArrayPrecioDESC('precio')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("precio")}}
                                    </th>
                                    <th v-if="ordenarTotal===0" @click="sortedArrayTotalASC('total')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("total")}}
                                    </th>
                                    <th v-else @click="sortedArrayTotalDESC('total')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("total")}}
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="obj in list">
                                        <td>{{obj.name}}</td>
                                        <td align="right">{{parseFloat(obj.units).toFixed(3)}}</td>
                                        <td align="right">{{obj.price | currency}}</td>
                                        <td align="right">{{obj.amount | currency}}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                <tr class="table-success">
                                    <td><strong>{{$t("total")}}</strong></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right"><strong>{{getTotalPrecio | currency}}</strong></td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>

                    </template>
                </template>
                <template v-else>
                    <div class="alert alert-danger" role="alert">
                        {{$t("noHay")}} <strong>{{$t("ventasPorProductos")}}</strong> {{$t("rangoDeFechas")}}
                    </div>
                </template>
            </div>

        </div>
    </div>

</template>

<script>
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Loading, Checkbox, CheckboxGroup} from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import Ticket from '../../../Widgets/Ticket.vue'
    import { mapState } from 'vuex'

    export default {
        created() {
            this.loadingNuevo = Loading.service({ text: this.$t('cargando') });
            this.$store.dispatch("setNameRoute", "Histórico de ventas de productos de pedidos");
            this.getCompanies();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }
        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            'ticket': Ticket
        },
        data() {
            return {
                loading: false,
                loadingNuevo: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                listBusinesses: [],
                idBusiness: 0,
                list: [],
                listCompany: [],
                idCompany: 0,

                ordenarTotal: 0,
                ordenarPrecio: 0,
                ordenarCantidad: 0,
                ordenarProducto: 0,

                respuesta: true,

                mostrarRecoger: true,
                mostrarDomicilio: true,

                ticketMedioRecoger: 0,
                ticketMedioDomicilio: 0
            }
        },
        computed: {
            ...mapState(["permiso"]),
            urlExportPDF() {
                return this.$store.getters.apiUrl+"/pedidos/exportGroupedProductsPedidos/PDF?idCompany="+ this.idCompany +"&idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&mostrarRecoger=" + this.mostrarRecoger + "&mostrarDomicilio="+ this.mostrarDomicilio +"&jwt=" + this.$store.getters.jwt
            },

            urlExportExcel() {
                return this.$store.getters.apiUrl+"/pedidos/exportGroupedProductsPedidos/Excel?idCompany="+ this.idCompany +"&idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&mostrarRecoger=" + this.mostrarRecoger + "&mostrarDomicilio="+ this.mostrarDomicilio +"&jwt=" + this.$store.getters.jwt
            },
            getTotalPrecioDto() {
                let total = 0;
                this.list.forEach(function (d) {
                    total += d.totalAmountSinDto;
                });
                return total;
            },
            getTotalPrecioDtoSinIVA() {
                let total = 0;
                this.list.forEach(function (d) {
                    total += d.totalAmountSinDtoSinIVA;
                });
                return total;
            },
            getTotalPrecio() {
                let total = 0;
                this.list.forEach(function (d) {
                    total += parseFloat(d.amount);
                });
                return total;
            },
            getTotalPagoSaldo(){
                let total = 0;
                this.list.forEach(function (d) {
                    total += d.amountPagoSaldo;
                });
                return total;
            },
            getTotalPrecioSinIVA() {
                let total = 0;
                this.list.forEach(function (d) {
                    total += d.amountSinIVA;
                });
                return total;
            },
            getTotalConsumiciones() {
                let total = 0;
                this.list.forEach(function (d) {
                    total += d.units;
                });
                return total;
            },
            getTotalComensales() {
                let total = 0;
                this.list.forEach(function (d) {
                    total += d.numComensales;
                });
                return total;
            },
            getTotalInvitacion() {
                let total = 0;
                this.list.forEach(function (d) {
                    total += d.invitations;
                });
                return total;
            },
            getTotalMedia() {
                let total = 0;
                this.list.forEach(function (d) {
                    total += d.amount / d.units;
                });
                return total;
            }
        },

        methods: {
            sortedArrayProductoASC: function () {
                this.ordenarProducto = 1;

                function compare(a, b) {
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayProductoDESC: function () {
                this.ordenarProducto = 0;

                function compare(a, b) {
                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },

            sortedArrayCantidadASC: function () {
                this.ordenarCantidad = 1;

                function compare(a, b) {
                    if (a.units < b.units)
                        return -1;
                    if (a.units > b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayCantidadDESC: function () {
                this.ordenarCantidad = 0;

                function compare(a, b) {
                    if (a.units > b.units)
                        return -1;
                    if (a.units < b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },

            sortedArrayPrecioASC: function () {
                this.ordenarPrecio = 1;

                function compare(a, b) {
                    if (a.price < b.price)
                        return -1;
                    if (a.price > b.price)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayPrecioDESC: function () {
                this.ordenarPrecio = 0;

                function compare(a, b) {
                    if (a.price > b.price)
                        return -1;
                    if (a.price < b.price)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },

            sortedArrayTotalASC: function () {
                this.ordenarTotal = 1;

                function compare(a, b) {
                    if (a.amount < b.amount)
                        return -1;
                    if (a.amount > b.amount)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayTotalDESC: function () {
                this.ordenarTotal = 0;

                function compare(a, b) {
                    if (a.amount > b.amount)
                        return -1;
                    if (a.amount < b.amount)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },

            getCompanies() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
                    .then(function (response) {
                        if (!vm.idCompany) {
                            vm.idCompany = response.data.result[0].id;
                        }

                        vm.listCompany = response.data.result;
                        vm.getBusiness()
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getBusiness() {
                var config = {
                    params: {
                        idCompany: this.idCompany,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByCompany", config)
                    .then(function (response) {
                        vm.listBusinesses = [];
                        vm.mostrarRecoger = true;
                        vm.mostrarRecoger = true;

                        if (response.data.result.length > 0) {
                            let xDate = {
                                checked: false,
                                establishmentName: vm.$t('todos'),
                                id: 0
                            };

                            vm.listBusinesses.push(xDate);
                        }

                        for (let i = 0; i < response.data.result.length; i++) {
                            let xDate = {
                                checked: response.data.result[i].checked,
                                establishmentName: response.data.result[i].establishmentName,
                                id: response.data.result[i].id
                            };

                            vm.listBusinesses.push(xDate);
                        }

                        vm.loadingNuevo.close();
                        vm.getSalesProducts();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            getSalesProducts() {
                if (!this.mostrarRecoger && !this.mostrarDomicilio) {
                    swal({
                        title: this.$t('ups'),
                        text: "Seleccione al menos un filtro RECOGER / DOMICILIO",
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                    this.loadingNuevo.close();
                    return;
                }

                this.loadingNuevo = Loading.service({ text: this.$t('cargando') });

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                    this.loadingNuevo.close();
                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        this.loadingNuevo.close();
                    } else {
                        this.loading = true;

                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                idCompany: this.idCompany,
                                mostrarRecoger: this.mostrarRecoger,
                                mostrarDomicilio: this.mostrarDomicilio,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.axios.get(this.$store.getters.apiUrl + "pedidos/getGroupedProductsPedidos", config)
                            .then(function (response) {
                                if (response.data.response) {
                                    let xresponse =  response.data.result;

                                    vm.list = xresponse.data;
                                    vm.ticketMedioRecoger = xresponse.ticketMedioRecoger;
                                    vm.ticketMedioDomicilio = xresponse.ticketMedioDomicilio;


                                    vm.respuesta = true;
                                } else if (response.data.response == false && response.data.rangoMayor == true) {
                                    swal({
                                        title: "Lo sentimos",
                                        text: response.data.result,
                                        confirmButtonClass: "btn btn-info btn-fill",
                                        type: "info",
                                    });
                                    vm.respuesta = false;
                                } else {
                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                    vm.respuesta = false;

                                }
                                vm.loading = false;
                                vm.loadingNuevo.close();

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },
        }
    }
</script>
<style scoped>
    a li {
        color: #111;
    }
    .card {
        padding: 20px;
    }
    .div-export {
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Pedidos/InformeVentasProductosPedidos.vue